import { render, staticRenderFns } from "./CreateOrModifyVideo.vue?vue&type=template&id=6270830c"
import script from "./CreateOrModifyVideo.vue?vue&type=script&lang=js"
export * from "./CreateOrModifyVideo.vue?vue&type=script&lang=js"
import style0 from "./CreateOrModifyVideo.vue?vue&type=style&index=0&id=6270830c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports